import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Typography, TextField, Grid, Link } from '@material-ui/core';

import i18n from 'i18next';

import MenuItem from '@material-ui/core/MenuItem';
import useTempIEStyles from './useTempIEStyles';

import { regions } from '../../constants/regions';

const useStyles = makeStyles((theme) => ({
  root: {},
  margin: {
    margin: theme.spacing(1, 0),
  },
  header: {
    marginBottom: 16,
  },
  link: {
    marginBottom: 20,
  },
}));

const ForgotPasswordForm = ({
  values: { region, email },
  errors,
  touched,
  handleSubmit,
  handleChange,
  isValid,
  setFieldTouched,
  validateForm,
  codeSentMessage = '',
  errorMessage = '',
  onResendEmail,
  onChange,
}) => {
  const classes = useStyles();
  const ieStyles = useTempIEStyles();
  const history = useHistory();

  const change = async (event) => {
    onChange(event);
    event.persist();
    const target = event.target;

    setFieldTouched(target.id, true, false);
    await handleChange(event);

    if (!isValid) {
      validateForm();
    }
  };

  const handleBackToLoginClick = () => {
    history.push('/login');
  };

  return (
    <div className={classes.root}>
      <header className={classes.header}>
        <Typography variant="h2">{i18n.t('forgot:title')}</Typography>
        <Typography variant="subtitle1">{i18n.t('forgot:sub')}</Typography>

        {errorMessage && (
          <Typography variant="subtitle1" color="error">
            {errorMessage}
          </Typography>
        )}
      </header>
      {!codeSentMessage && (
        <form noValidate autoComplete="off" onSubmit={handleSubmit}>
          <TextField
            id="region"
            name="region"
            size="small"
            variant="outlined"
            className={classes.margin}
            fullWidth
            select
            label={i18n.t('forgot:form:region:label')}
            value={region}
            onChange={change}
            helperText={touched.region ? errors.region : ''}
            error={touched.region && Boolean(errors.region)}
          >
            {regions.map((option, index) => (
              <MenuItem className={ieStyles.menuItem} key={option.value} value={option.value}>
                {index === 0 ? i18n.t(`regions:${option.label}`) : option.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            id="email"
            name="email"
            variant="outlined"
            className={classes.margin}
            margin="dense"
            label={i18n.t('forgot:form:email:label')}
            fullWidth
            value={email}
            onChange={change}
            helperText={touched.email ? errors.email : ''}
            error={touched.email && Boolean(errors.email)}
          />
          <Grid container>
            <Grid item xs={12} sm={6}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.margin}
                type="submit"
                disabled={!isValid}
              >
                {i18n.t('forgot:form:buttons:submit')}
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                fullWidth
                color="primary"
                className={classes.margin}
                type="button"
                onClick={handleBackToLoginClick}
              >
                {i18n.t('forgot:form:buttons:cancel')}
              </Button>
            </Grid>
          </Grid>
        </form>
      )}

      {codeSentMessage && (
        <Fragment>
          {codeSentMessage && (
            <Typography variant="body1" gutterBottom>
              {codeSentMessage}
            </Typography>
          )}
          <Link
            className={classes.link}
            type="button"
            component="button"
            color="error"
            href="/forgot"
            onClick={onResendEmail}
          >
            {i18n.t('forgot:links:resend')}
          </Link>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="button"
            onClick={handleBackToLoginClick}
          >
            {i18n.t('forgot:form:buttons:return')}
          </Button>
        </Fragment>
      )}
    </div>
  );
};

ForgotPasswordForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  isValid: PropTypes.bool,
  touched: PropTypes.shape({}),
  setFieldTouched: PropTypes.func,
  errorMessage: PropTypes.string,
  codeSentMessage: PropTypes.string,
  values: PropTypes.shape({}),
  errors: PropTypes.shape({}),
  onChange: PropTypes.func,
  onResendEmail: PropTypes.func,
  validateForm: PropTypes.func,
};

export default ForgotPasswordForm;



// WEBPACK FOOTER //
// ./src/components/Login/ForgotPasswordForm.js